angular.module( 'acme.view.application.coupons.categories', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.coupons.categories.controllers',
  'acme.view.application.coupons.categories.create'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var couponsCategories = {
        name: 'application.coupons.categories',
        url: '/categories',
        views: {
          "subview-main": {
            controller: 'CouponsCategoriesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/coupons/categories/categories.tpl.html'
          }
        },
        data: {
          pageTitle: 'Coupon Categories',
          /** Secure With Roles **/
          permissions: ['COUPON_CATEGORIES_VIEW']
        }
      };

    $stateProvider
      .state(couponsCategories);
});
